"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzRow__Wrapper",
  componentId: "sc-16bmwdq-0"
})(["\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  grid-gap: ", "px;\n  align-items: ", ";\n"], function (props) {
  return props.gap;
}, function (props) {
  return props.align;
});

var OzRow = function OzRow(_ref) {
  var _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 20 : _ref$gap,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "top" : _ref$align,
      children = _ref.children;
  return __jsx(Wrapper, {
    align: align,
    gap: gap
  }, children);
};

var _default = OzRow;
exports.default = _default;